import { SettlementService } from "../settlementservices/settlementservice";
export class Settlement {
    CityMilesSq;
    CityPopulation;
    CountrysideMilesSq;
    CountrysidePopulation;
    Services;
    SupportingVillages;
    TotalBuildings;
    constructor(cityPopulation, advancedSettings) {
        this.CityPopulation = cityPopulation;
        const farmsPerMile = 640 / advancedSettings.AverageFarmSizeAcres;
        const averageDensity = farmsPerMile * advancedSettings.HouseholdSize;
        const supportingPopulationPerSqMile = advancedSettings.PeoplePerSqMileFarmland - averageDensity;
        const milesSqOfFarmlandToSupportCity = cityPopulation / supportingPopulationPerSqMile;
        const peopleFarmingToSupportCity = milesSqOfFarmlandToSupportCity * averageDensity;
        this.CountrysidePopulation = Math.floor(peopleFarmingToSupportCity);
        this.CountrysideMilesSq = milesSqOfFarmlandToSupportCity;
        this.SupportingVillages = Math.floor(this.CountrysideMilesSq / 3);
        this.CityMilesSq = cityPopulation / advancedSettings.CityPeoplePerSqMile;
        this.TotalBuildings = Math.floor(cityPopulation / advancedSettings.HouseholdSize * advancedSettings.WarehousesPerBuildingMultiplier);
        this.Services = [];
        const potentialServices = SettlementService.GetServices();
        for (const service of potentialServices) {
            const numServices = Math.floor(this.CityPopulation / service.SupportValue);
            for (let y = 0; y < numServices; y++) {
                this.Services.push(new SettlementService(service.Name, service.SupportValue));
            }
        }
    }
    GetTotalPopulation() {
        return this.CityPopulation + this.CountrysidePopulation;
    }
    GetTotalSizeAcres() {
        return this.CityMilesSq + this.CountrysideMilesSq;
    }
}
//# sourceMappingURL=settlement.js.map